import BaseSportScoring from './BaseSportScoring';

/**
 * BadmintonScoring handles both singles and doubles.
 * Pass isDoubles=true for doubles variant (uses badminton_doubles config).
 */
class BadmintonScoring extends BaseSportScoring {
  constructor(isDoubles = false) {
    super(isDoubles ? 'badminton_doubles' : 'badminton');
    this.isDoubles = isDoubles;
  }

  get label() { return this.isDoubles ? 'Badminton (Doubles)' : 'Badminton'; }
}

export default BadmintonScoring;
